import React from 'react';
// import './Footer.css';
const Footer = () => {
  return (
    <footer className="footer">
      <p>© GDG Management Marketing task | Designed with ❤️ by Devyani Keche</p>
    </footer>
  );
}

export default Footer;
